import { Container, Stack, Typography } from '@mui/material';
import { useRouteError } from 'react-router';

import { formatErrorMessage } from './format-error-message';

export function Error() {
  const error = useRouteError();
  const errorMessage = formatErrorMessage(error);
  return (
    <Container>
      <Stack
        spacing={3}
        sx={{ mt: 10, alignItems: 'center', justifyItems: 'center' }}
      >
        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
          Oups 💣 🫢
        </Typography>
        <Typography sx={{}}>
          <i>{errorMessage}</i>
        </Typography>
      </Stack>
    </Container>
  );
}
